<template>
  <div class="wrap">
    <div class="pop">
      <p class="title">
        <span>{{title}}</span>
        <img @click="closePop(1)" class="close" src="../../../assets/image/icon/closePop.png" alt="">  
      </p>
      <div class="content" v-html="getXssIntro(content)"></div>
      <p class="btn" @click="closePop(0)">我已阅读</p>
    </div>
  </div>
</template>
<script>
import { getAgreement } from '@/api/login'
import { getXssIntro } from '@/utils/xss'

export default {
  data () {
    return {
      type: 1,
      content: '',
      title: ''
    }
  },
  methods: {
    getXssIntro,
    closePop (closeType) {
      this.$emit('closePop',{ closeType, type: this.type })
    },
    async getContent (type) {
      this.type = type
      try {
        const { code, result: { protocolContent, protocolTitle } } = await getAgreement({ name: type === 1 ? 'platform' : 'privacy' })
        if (code !== 200) return
        this.content = protocolContent
        this.title = protocolTitle
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .wrap{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 1000;
    .pop {
      width: 860px;
      height: 600px;
      overflow-y: auto;
      background: #fff;
      position: absolute;
      top: calc(50% - 300px);
      left: calc(50% - 400px);
      box-shadow: 0px 12px 30px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 0 20px;
      .title {
        text-align: center;
        height: 88px;
        line-height: 88px;
        font-weight: 700;
        color: #222222;
        font-size: 20px;
        margin: 0;
      }
      .close {
        float: right;
        width: 18px;
        cursor: pointer;
        margin-top: 35px;
      }
      .content {
        color: #000;
        height: 416px;
        overflow-y: auto;
        padding: 0 20px;
        /deep/ img {
          max-width: 780px;
        }
      }
      .btn {
        width: 122px;
        height: 40px;
        background: #4B7EFE;
        border-radius: 2px;
        color: #FFFFFF;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        margin: 0 auto;
        margin-top: 24px;
        cursor: pointer;
      }
    }
  }
</style>